import alterReplace from '@/functions/alterStrReplace'
import moment from 'moment'
// balloonを処理する際のメソッドをまとめて書いたもの

function messageEscape(m, roboArguments=[]) {
  m = replaceRoboArguments(m, roboArguments)
  return alterReplace(m, true)
}

function iconCreate(icon, isBot, isManager) {
  if (icon !== '' && isManager !== '0') {
    return icon
  } else if (icon === '' && isBot) {
    return require('../assets/template/robot.png')
  } else {
    return require('../assets/template/human.png')
  }
}

function messageCreate(m, roboArguments) {
  if (m.indexOf('[msg]') > -1 || m.indexOf('[input]') > -1) {
    var firstText = m.split('|')
    var text = firstText[0]
      .replace('[msg]', '')
      .replace('[/msg]', '')
      .replace('[input]', '')
      .replace('[/input]', '')
    text = replaceRoboArguments(text.split(',')[0], roboArguments)
    return alterReplace(text, true)
  } else {
    return '下記ボタンを選択してください'
  }
}

function buttonCreate(m, roboArguments) {
  if (m.indexOf('[msg]') < 0 && m.indexOf('[url]') > 0 && m.indexOf('[/url]') > 0) {
    m = replaceRoboArguments(m, roboArguments)
    var text = m
      .replace('[button]', '')
      .replace('[/button]', '')
      .replace('[url]', '')
      .replace('[/url]', '')
    return alterReplace(text.split(',')[1], true)
  } else if (m.indexOf('[msg]') < 0) {
    var text = m.replace('[button]', '').replace('[/button]', '')
    text = replaceRoboArguments(text.split(',')[0], roboArguments)
    return alterReplace(text, true)
  } else {
    return ''
  }
}

function urlCreate(m, roboArguments) {
  if (m.indexOf('[msg]') < 0 && m.indexOf('[url]') > 0 && m.indexOf('[/url]') > 0) {
    var text = m
      .replace('[button]', '')
      .replace('[/button]', '')
      .replace('[url]', '')
      .replace('[/url]', '')
    if (text.split(',')[0].slice(-1) == '^') {
      text = replaceRoboArguments(text.split(',')[0].slice(0, -1), roboArguments)
    } else {
      text = replaceRoboArguments(text.split(',')[0], roboArguments)
    }
    return text
  } else {
    return ''
  }
}

function imageCreate(m) {
  if (m.indexOf('[msg]') > -1) {
    var text = m
      .replace('[msg]', '')
      .replace('[/msg]|', '')
      .replace('[image]', '')
      .replace('[/image]', '')
    return alterReplace(text, true)
  } else {
    return ''
  }
}

function colorCreate(m, roboArguments) {
  var text = []
  if (m.indexOf('[url]') > 0 && m.indexOf('[/url]') > 0) {
    text = m
      .replace('[button]', '')
      .replace('[/button]', '')
      .replace('[url]', '')
      .replace('[/url]', '')
    return text.split(',')[2]
  } else {
    text = m.replace('[button]', '').replace('[/button]', '')
    text = replaceRoboArguments(text.split(',')[1], roboArguments)
    return text
  }
}

function formCheckBoxCreate(m, roboArguments) {
  if (m.indexOf('[msg]') > -1 || m.indexOf('[checkbox]') > -1) {
    var firstText = m.split('|')
    var text = firstText[0]
      .replace('[msg]', '')
      .replace('[/msg]', '')
      .replace('[checkbox]', '')
      .replace('[/checkbox]', '')
    if (text === '') text = '該当項目にチェックをお願いします。'
    text = replaceRoboArguments(text.split(',')[0], roboArguments)
    return alterReplace(text, true)
  }
}

function formMessageCreate(m, roboArguments) {
  if (m.indexOf('[msg]') > -1 || m.indexOf('[cv]') > -1 || m.indexOf('[search]') > -1) {
    var firstText = m.split('|')
    var text = firstText[0]
      .replace('[msg]', '')
      .replace('[/msg]', '')
      .replace('[cv]', '')
      .replace('[/cv]', '')
      .replace('[search]', '')
      .replace('[/search]', '')
    if (text === '')
      text = '応募フォームはこちらになります！ご記入のほど、よろしくお願いいたします！'
    text = replaceRoboArguments(text.split(',')[0], roboArguments)
    return alterReplace(text, true)
  }
}

function movieCreate(m) {
  if (m.indexOf('[msg]') > -1) {
    var firstText = m.split('|')
    var text = firstText[0]
      .replace('[msg]', '')
      .replace('[/msg]', '')
      .replace('[movie]', '')
      .replace('[/movie]', '')
    return alterReplace(text, true)
  } else {
    return ''
  }
}

function pulldownMessageCreate(m, roboArguments) {
  if (m.indexOf('[msg]') > -1 || m.indexOf('[pulldown]') > -1) {
    var firstText = m.split('|')
    var text = firstText[0]
      .replace('[msg]', '')
      .replace('[/msg]', '')
      .replace('[pulldown]', '')
      .replace('[/pulldown]', '')
    if (text === '') text = 'プルダウンから選択をお願いします。'
    text = replaceRoboArguments(text, roboArguments)
    return alterReplace(text, true)
  }
}

function downloadCreate(m, roboArguments) {
  if (m.indexOf('[msg]') > -1 || m.indexOf('[filedownload]') > -1) {
    var firstText = m.split('|')
    var text = firstText[0]
      .replace('[msg]', '')
      .replace('[/msg]', '')
      .replace('[filedownload]', '')
      .replace('[/filedownload]', '')
    if (text === '') text = '以下からダウンロードしてください。'
    text = replaceRoboArguments(text, roboArguments)
    return alterReplace(text, true)
  }
}

function outputCreate(m) {
  if (m.indexOf('[msg]') > -1 || m.indexOf('[output]') > -1) {
    var firstText = m.split('|')
    var text = firstText[0]
      .replace('[msg]', '')
      .replace('[/msg]', '')
      .replace('[output]', '')
      .replace('[/output]', '')
    return alterReplace(text, true)
  }
}

function pdfDownloadCreate(m, roboArguments) {
  if (m.indexOf('[msg]') > -1 || m.indexOf('[pdf-download]') > -1) {
    var firstText = m.split('|')
    var text = firstText[0]
      .replace('[msg]', '')
      .replace('[/msg]', '')
      .replace('[pdf-download]', '')
      .replace('[/pdf-download]', '')
    if (text === '') text = '以下のボタンからPDFをダウンロードしてください。'
    text = replaceRoboArguments(text, roboArguments)
    return alterReplace(text, true)
  }
}

function isMessage(m) {
  return (
    isButton(m) &&
    isCVForm(m) &&
    isCalendar(m) &&
    isImage(m) &&
    isInput(m) &&
    isFileUpload(m) &&
    isResume(m) &&
    isCheckBox(m) &&
    isMovie(m) &&
    isPullDown(m) &&
    isCarousel(m) &&
    isFileDownload(m) &&
    isOutput(m)
  )
}
function isButton(m) {
  if (m === '' && m.indexOf('[button]') === -1 && m.indexOf('[/button]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[button]') === -1 && m.indexOf('[/button]') === -1
  }
}
function isCVForm(m) {
  if (m === '' && m.indexOf('[cv]') === -1 && m.indexOf('[/cv]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[cv]') === -1 && m.indexOf('[/cv]') === -1
  }
}
function isCalendar(m) {
  if (m === '' && m.indexOf('[calendar]') === -1 && m.indexOf('[/calendar]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[calendar]') === -1 && m.indexOf('[/calendar]') === -1
  }
}
function isFileUpload(m) {
  if (m === '' && m.indexOf('[fileupload]') === -1 && m.indexOf('[/fileupload]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[fileupload]') === -1 && m.indexOf('[/fileupload]') === -1
  }
}
function isImage(m) {
  if (m === '' && m.indexOf('[image]') === -1 && m.indexOf('[/image]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[image]') === -1 && m.indexOf('[/image]') === -1
  }
}
function isInput(m) {
  if (m === '' && m.indexOf('[input]') === -1 && m.indexOf('[/input]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[input]') === -1 && m.indexOf('[/input]') === -1
  }
}
function isResume(m) {
  if (m === '' && m.indexOf('[resume]') === -1 && m.indexOf('[/resume]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[resume]') === -1 && m.indexOf('[/resume]') === -1
  }
}
function isCheckBox(m) {
  if (m === '' && m.indexOf('[checkbox]') === -1 && m.indexOf('[/checkbox]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[checkbox]') === -1 && m.indexOf('[/checkbox]') === -1
  }
}
function isFiles(m) {
  return m == '' || !m
}
function isMovie(m) {
  if (m === '' && m.indexOf('[movie]') === -1 && m.indexOf('[/movie]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[movie]') === -1 && m.indexOf('[/movie]') === -1
  }
}
function isPullDown(m) {
  if (m === '' && m.indexOf('[pulldown]') === -1 && m.indexOf('[/pulldown]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[pulldown]') === -1 && m.indexOf('[/pulldown]') === -1
  }
}
function isCarousel(m) {
  if (m === '' && m.indexOf('[carousel]') === -1 && m.indexOf('[/carousel]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[carousel]') === -1 && m.indexOf('[/carousel]') === -1
  }
}
function isFileDownload(m) {
  if (m === '' && m.indexOf('[filedownload]') === -1 && m.indexOf('[/filedownload]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[filedownload]') === -1 && m.indexOf('[/filedownload]') === -1
  }
}
function isOutput(m) {
  if (m === '' && m.indexOf('[output]') === -1 && m.indexOf('[/output]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[output]') === -1 && m.indexOf('[/output]') === -1
  }
}
function isSearch(m) {
  if (m === '' && m.indexOf('[search]') === -1 && m.indexOf('[/search]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[search]') === -1 && m.indexOf('[/search]') === -1
  }
}
function isPdfDownload(m) {
  if (m === '' && m.indexOf('[pdf-download]') === -1 && m.indexOf('[/pdf-download]') === -1) {
    return true
  } else {
    return m !== '' && m.indexOf('[pdf-download]') === -1 && m.indexOf('[/pdf-download]') === -1
  }
}
function isResumePdf(m) {
  return m == '' || !m
}
function isNowButton(logIndex, lastIndex, speaker) {
  if (logIndex >= lastIndex) {
    return false
  } else if (logIndex >= lastIndex - 1 && speaker === 'my') {
    return false
  } else {
    return true
  }
}
// ダウンロードボタン活性化用のメソッド
function isDownloadClick(downloadFlg) {
  downloadFlg = true
  return downloadFlg
}
function autoColor(color) {
  var cl = '#000'
  if (color[0] * 0.299 + color[1] * 0.587 + color[2] * 0.114 < 206) {
    cl = '#FFF'
    return cl
  } else {
    return cl
  }
}
function shadowStyle(type) {
  if (type === 0) {
    return 'drop-shadow(0px 0px 0px rgba(0,0,0,0.2))'
  } else {
    return 'drop-shadow(1px 1px 1px rgba(0,0,0,0.2))'
  }
}
function convertMesasge(m, color, roboArguments) {
  let cl = '#0483FA'
  if (color[0] * 0.299 + color[1] * 0.587 + color[2] * 0.114 < 206) {
    cl = '#E0FDFB'
  }
  const reg = new RegExp("((https?|ftp)(://[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+))")
  m = replaceRoboArguments(m, roboArguments)
  if (m.indexOf('[msg]') > -1) {
    let firstText = m.split('|')
    let text = firstText[0].replace('[msg]', '').replace('[/msg]', '')
    let cleanUpBCText = cleanUpTextBackgroundColor(text)
    let cleanUpText = cleanUpTextComma(cleanUpBCText)
    cleanUpText = replaceRoboArguments(cleanUpText, roboArguments)
    return messageEscape(cleanUpText)
  } else {
    return messageEscape(
      m.replace(reg, "<a style='color: ' + cl + '' href='$1' target='_blank'>$1</a>")
    )
  }
}

const cleanUpTextBackgroundColor = (text) => {
  const backGroundColor = /style=\"background-color: rgb\(252, 252, 252\);\"/g
  return text.replace(backGroundColor, '')
}

const cleanUpTextComma = (text) => {
  return text.split(',')[0]
}

const replaceApplyWord = (text, c) => {
  if (text) {
    const replaceGender = ['未選択', '男性', '女性', '選択しない'][c.quoteAnswers.gender]
    let replaceBirth = moment(c.quoteAnswers.birth).format('YYYY/MM/DD')
    if (replaceBirth === 'Invalid date') replaceBirth = ''

    return text
      .replace(new RegExp(c.quoteWords.name, 'g'), c.quoteAnswers.name)
      .replace(new RegExp(c.quoteWords.furigana, 'g'), c.quoteAnswers.furigana)
      .replace(new RegExp(c.quoteWords.email, 'g'), c.quoteAnswers.email)
      .replace(new RegExp(c.quoteWords.tel, 'g'), c.quoteAnswers.tel)
      .replace(new RegExp(c.quoteWords.gender, 'g'), replaceGender)
      .replace(new RegExp(c.quoteWords.address, 'g'), c.quoteAnswers.address)
      .replace(new RegExp(c.quoteWords.birth, 'g'), replaceBirth)
      .replace(new RegExp(c.quoteWords.message, 'g'), c.quoteAnswers.msg)
  } else {
    console.error('replace error replaceApplyWord')
    return text
  }
}

const replacePulldownWord = (text, c, roboArguments) => {
  if (text) {
    const keys = Object.keys(c.quoteAnswers)
    for (let k of keys) {
      if (c.quoteWords[k] && c.quoteAnswers[k])
        text = text.replace(new RegExp(c.quoteWords[k], 'g'), c.quoteAnswers[k])
    }
    if (c.quoteWords.answer) text = text.replace(new RegExp(c.quoteWords.answer, 'g'), c.message)
    text = replaceRoboArguments(text, roboArguments)
    return text
  } else {
    console.error('replace error replacePulldownWord')
    return text
  }
}

const replaceInputWord = (
  text,
  lsApplicant,
  lsEmail,
  lsTel,
  lsAddress,
  lsFurigana,
  lsYyyymmdd,
  lsYears,
  lsShikaku,
  lsCareer,
  lsBikou,
  date,
  lsPoint,
  roboArguments
) => {
  if (text) {
    text = replaceRoboArguments(text, roboArguments)
    return text
      .replace(new RegExp('__applicant__', 'g'), lsApplicant ? lsApplicant : '')
      .replace(new RegExp('__email__', 'g'), lsEmail ? lsEmail : '')
      .replace(new RegExp('__tel__', 'g'), lsTel ? lsTel : '')
      .replace(new RegExp('__address__', 'g'), lsAddress ? lsAddress : '')
      .replace(new RegExp('__furigana__', 'g'), lsFurigana ? lsFurigana : '')
      .replace(new RegExp('__yyyymmdd__', 'g'), lsYyyymmdd ? lsYyyymmdd : '')
      .replace(new RegExp('__years__', 'g'), lsYears ? lsYears : '')
      .replace(new RegExp('__shikaku__', 'g'), lsShikaku ? lsShikaku : '')
      .replace(new RegExp('__career__', 'g'), lsCareer ? lsCareer : '')
      .replace(new RegExp('__bikou__', 'g'), lsBikou ? lsBikou : '')
      .replace(new RegExp('__date__', 'g'), date ? date : '')
      .replace(new RegExp('__point__', 'g'), lsPoint ? lsPoint : '')
  } else {
    console.error('replace error replaceInputWord')
    return text
  }
}

const replaceFreeWord = (text, c) => {
  return text.replace(new RegExp(c.quoteWords.answer, 'g'), c.message)
}

const replaceWord = (text, c, roboArguments) => {
  text = replaceRoboArguments(text, roboArguments)
  if (c.status == 1 || c.status == 8) {
    // 応募フォーム or 履歴書フォームのとき
    return replaceApplyWord(text, c)
  } else if (c.status == 15) {
    // プルダウンのとき
    return replacePulldownWord(text, c, roboArguments)
  } else {
    return replaceFreeWord(text, c)
  }
}

const replaceCantReplaceWord = (text) => {
  // 置換できなかったロボ引用の引用文字列を削除する
  text = text.replace(new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'), '')
  return text.replace(new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'), '')
}

const replaceRoboArguments = (text, roboArguments=[]) => {
  if (text) {
    // ロボ引用がある場合
    for (const arg of roboArguments) {
      text = text.replace(new RegExp(arg.key, 'g'), arg.value)
    }
    // 置換できなかったロボ引用の引用文字列を削除する
    return text.replace(new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'), '')
  }
}

export {
  iconCreate,
  messageCreate,
  buttonCreate,
  urlCreate,
  imageCreate,
  colorCreate,
  formMessageCreate,
  formCheckBoxCreate,
  movieCreate,
  downloadCreate,
  outputCreate,
  isMessage,
  isButton,
  isCVForm,
  isCalendar,
  isFileUpload,
  isImage,
  isInput,
  isResume,
  isCheckBox,
  isFiles,
  isMovie,
  isPullDown,
  isCarousel,
  isFileDownload,
  isOutput,
  isSearch,
  isPdfDownload,
  isResumePdf,
  autoColor,
  shadowStyle,
  convertMesasge,
  isNowButton,
  isDownloadClick,
  messageEscape,
  pulldownMessageCreate,
  pdfDownloadCreate,
  replaceInputWord,
  replaceWord,
  replaceCantReplaceWord,
}



// WEBPACK FOOTER //
// ./src/functions/balloonFunc.js